/* Satya Heritage — product page, sticky add to cart, quick view, predictive search,
   collection filters, read-more clamps, countdown and lead tracking. */
(function () {
  "use strict";
  var S = window.Satya || {};
  var T = window.SatyaTheme || {};
  var R = T.routes || {};
  var root = S.root || "/";
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var money = S.money || function (c) { return "₹" + (c / 100).toLocaleString("en-IN"); };
  var esc = S.esc || function (s) { return String(s); };
  var clean = S.cleanTitle || function (s) { return s; };
  var RM = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var mqMobile = window.matchMedia("(max-width: 767px)");

  /* ============ product page ============ */
  var ps = $("[data-product-section]");
  if (ps) {
    var pj = JSON.parse($("[data-product-json]", ps).textContent);
    var form = $("[data-product-form]", ps);
    var addBtn = $("[data-add-btn]", ps), buyNow = $("[data-buy-now]", ps);
    var sticky = $("[data-sticky-atc]", ps), sBtn = sticky && $("[data-sticky-btn]", sticky);
    var picker = $(".pdp__options", ps);
    var gallery = $("[data-gallery]", ps), track = gallery && $("[data-track]", gallery);

    var selected = function () {
      var vals = [];
      (pj.options || []).forEach(function (_, i) {
        var c = $('[data-option="' + i + '"]:checked', ps);
        vals[i] = c ? c.value : null;
      });
      return vals;
    };
    var findVariant = function (vals) {
      return pj.variants.filter(function (v) { return v.options.every(function (o, i) { return o === vals[i]; }); })[0];
    };
    var current = function () { return findVariant(selected()); };

    /* cross out option values that are sold out with the other current choices */
    var markAvailability = function () {
      var vals = selected();
      (pj.options || []).forEach(function (_, i) {
        $$('[data-option="' + i + '"]', ps).forEach(function (inp) {
          var test = vals.slice(); test[i] = inp.value;
          var v = findVariant(test);
          inp.closest(".pill").classList.toggle("unavailable", !v || !v.available);
        });
        var lab = $('[data-option-value="' + i + '"]', ps); if (lab) lab.textContent = vals[i] || "";
      });
    };

    var goToMedia = function (mediaId) {
      if (!track) return;
      var slide = $('.pg__slide[data-media-id="' + mediaId + '"]', track);
      if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: RM ? "auto" : "smooth" });
    };

    var update = function () {
      var v = current();
      var price = $("[data-price]", ps), cmp = $("[data-compare]", ps);
      markAvailability();
      if (!v) {
        addBtn.disabled = true; addBtn.textContent = "Unavailable"; if (buyNow) buyNow.disabled = true;
        syncSticky(); return;
      }
      $("[data-variant-id]", ps).value = v.id;
      price.textContent = money(v.price);
      var saleBox = price.closest("[data-sale-pct]"), salePct = saleBox ? parseInt(saleBox.dataset.salePct, 10) || 0 : 0, sp = $("[data-sale-price]", ps);
      if (sp && salePct) sp.textContent = money(Math.floor(v.price * (100 - salePct) / 100));
      if (!salePct && v.compare_at_price && v.compare_at_price > v.price) { cmp.hidden = false; cmp.textContent = money(v.compare_at_price); } else cmp.hidden = true;
      addBtn.disabled = !v.available; addBtn.textContent = v.available ? "Add to cart" : "Sold out";
      if (buyNow) buyNow.disabled = !v.available;
      if (v.featured_media) goToMedia(v.featured_media.id);
      var url = new URL(location.href); url.searchParams.set("variant", v.id); history.replaceState({}, "", url);
      syncSticky();
    };

    var syncSticky = function () {
      if (!sticky) return;
      var v = current();
      var p = $("[data-sticky-price]", sticky), vn = $("[data-sticky-variant]", sticky);
      if (!v) {
        sBtn.disabled = false; sBtn.textContent = "Choose options"; sBtn.dataset.mode = "choose";
        if (vn) vn.textContent = ""; return;
      }
      var spEl = $("[data-sale-pct]", ps), spc = spEl ? parseInt(spEl.dataset.salePct, 10) || 0 : 0;
      if (p) p.textContent = money(spc ? Math.floor(v.price * (100 - spc) / 100) : v.price);
      if (vn) vn.textContent = v.title && v.title !== "Default Title" ? " · " + v.title : "";
      if (sBtn.classList.contains("is-loading")) return;
      sBtn.disabled = !v.available; sBtn.textContent = v.available ? "Add to cart" : "Sold out"; sBtn.dataset.mode = v.available ? "add" : "soldout";
    };

    ps.addEventListener("change", function (e) { if (e.target.matches("[data-option]")) update(); });
    ps.addEventListener("click", function (e) {
      var q = e.target.closest("[data-qty]");
      if (q) { var inp = $('[name="quantity"]', form); inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(q.dataset.qty, 10)); }
    });

    /* gallery: swipe track, dots, thumbnails, zoom */
    if (track) {
      var dots = $$(".pg__dots i", gallery), thumbs = $$("[data-thumb]", gallery), slides = $$(".pg__slide", track);
      var setActive = function (n) {
        dots.forEach(function (d, i) { d.classList.toggle("on", i === n); });
        thumbs.forEach(function (t, i) { if (i === n) t.setAttribute("aria-current", "true"); else t.removeAttribute("aria-current"); });
      };
      var tick = false;
      track.addEventListener("scroll", function () {
        if (tick) return; tick = true;
        requestAnimationFrame(function () { tick = false; setActive(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); });
      }, { passive: true });
      thumbs.forEach(function (t, i) { t.addEventListener("click", function () { track.scrollTo({ left: slides[i].offsetLeft, behavior: RM ? "auto" : "smooth" }); setActive(i); }); });
      var dlg = $("[data-zoom-dialog]", ps), zimg = dlg && $("[data-zoom-img]", dlg);
      if (dlg && dlg.showModal) {
        slides.forEach(function (s) {
          s.addEventListener("click", function () { zimg.src = s.dataset.zoom; zimg.alt = (s.querySelector("img") || {}).alt || ""; dlg.showModal(); });
        });
        $("[data-zoom-close]", dlg).addEventListener("click", function () { dlg.close(); });
        dlg.addEventListener("click", function (e) { if (e.target === dlg) dlg.close(); });
        zimg.addEventListener("click", function () { zimg.classList.toggle("is-zoomed"); });
      }
      /* start on the selected variant's image */
      var v0 = current(); if (v0 && v0.featured_media) setTimeout(function () { var sl = $('.pg__slide[data-media-id="' + v0.featured_media.id + '"]', track); if (sl) { track.scrollLeft = sl.offsetLeft; } }, 0);
    }

    /* sticky add to cart */
    if (sticky && addBtn && "IntersectionObserver" in window) {
      document.body.appendChild(sticky);
      var past = false;
      var visibleNow = function () { return getComputedStyle(sticky).display !== "none"; };
      var show = function (on) {
        if (on) { sticky.hidden = false; requestAnimationFrame(function () { sticky.classList.add("on"); }); }
        else sticky.classList.remove("on");
        document.body.classList.toggle("has-sticky-atc", on && visibleNow());
      };
      new IntersectionObserver(function (es) {
        var e = es[0]; past = !e.isIntersecting && e.boundingClientRect.top < 0; show(past);
      }).observe(addBtn);
      sBtn.addEventListener("click", function () {
        var mode = sBtn.dataset.mode;
        if (mode === "choose" || !current()) {
          var target = picker || form;
          window.scrollTo({ top: target.getBoundingClientRect().top + scrollY - 90, behavior: RM ? "auto" : "smooth" });
          return;
        }
        var v = current(); if (!v || !v.available) return;
        var q = $('[name="quantity"]', form);
        if (S.addAndOpen) S.addAndOpen(v.id, q ? Math.max(1, parseInt(q.value, 10) || 1) : 1, sBtn);
      });
      mqMobile.addEventListener && mqMobile.addEventListener("change", function () { show(past); });
      syncSticky();
    }
    markAvailability();
  }

  /* ============ recommendations (shown only when there are products) ============ */
  $$("[data-recs-load]").forEach(function (box) {
    fetch(box.dataset.recsLoad).then(function (r) { return r.ok ? r.text() : ""; }).then(function (html) {
      var d = document.createElement("div"); d.innerHTML = html;
      var cards = d.querySelectorAll(".card");
      if (!cards.length) { box.parentNode && box.parentNode.removeChild(box); return; }
      var grid = $("[data-recs-grid]", box);
      Array.prototype.forEach.call(cards, function (c) { grid.appendChild(c); });
      box.hidden = false;
    }).catch(function () { box.parentNode && box.parentNode.removeChild(box); });
  });

  /* ============ quick view (products with options) ============ */
  var qv;
  function buildQV() {
    qv = document.createElement("dialog");
    qv.className = "qv"; qv.setAttribute("aria-label", "Choose options");
    qv.innerHTML = '<div class="qv__in"><button type="button" class="qv__close icon-btn" aria-label="Close"><svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18"/></svg></button><div class="qv__body"></div></div>';
    document.body.appendChild(qv);
    $(".qv__close", qv).addEventListener("click", function () { qv.close(); });
    qv.addEventListener("click", function (e) { if (e.target === qv) qv.close(); });
    qv.addEventListener("close", function () { document.body.classList.remove("qv-open"); });
    return qv;
  }
  function openQV(handle, trigger) {
    if (!qv) buildQV();
    var body = $(".qv__body", qv);
    body.innerHTML = '<div class="qv__loading">Loading…</div>';
    if (qv.showModal) qv.showModal(); else qv.setAttribute("open", "");
    document.body.classList.add("qv-open");
    var qvSale = trigger && trigger.dataset ? parseInt(trigger.dataset.sale, 10) || 0 : 0;
    var qvMoney = function (c) { return qvSale ? money(Math.floor(c * (100 - qvSale) / 100)) + " <s>" + money(c) + '</s> <span class="qv__sale">' + qvSale + "% OFF</span>" : money(c); };
    fetch(root + "products/" + encodeURIComponent(handle) + ".js").then(function (r) { if (!r.ok) throw new Error("Could not load product"); return r.json(); }).then(function (p) {
      var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
      var opts = (p.options || []).map(function (o, i) {
        var vals = o.values || [];
        return '<fieldset class="opt"><legend class="opt__label">' + esc(o.name) + ': <span data-qv-val="' + i + '">' + esc(first.options[i]) + '</span></legend><div class="opt__pills">' +
          vals.map(function (val) { return '<label class="pill"><input type="radio" name="qv' + i + '" value="' + esc(val) + '" data-qv-opt="' + i + '"' + (first.options[i] === val ? " checked" : "") + "><span>" + esc(val) + "</span></label>"; }).join("") + "</div></fieldset>";
      }).join("");
      var img = p.featured_image ? (p.featured_image.indexOf("//") === 0 ? "https:" + p.featured_image : p.featured_image) : "";
      body.innerHTML = '<div class="qv__media">' + (img ? '<img src="' + img + (img.indexOf("?") > -1 ? "&" : "?") + 'width=700" alt="" width="350" height="350">' : "") + "</div>" +
        '<div class="qv__info"><h2 class="qv__t">' + esc(clean(p.title)) + '</h2><p class="qv__price" data-qv-price>' + qvMoney(first.price) + "</p>" + opts +
        '<div class="buyrow"><div class="qty"><button type="button" data-qv-q="-1" aria-label="Decrease quantity">−</button><input type="number" value="1" min="1" aria-label="Quantity" data-qv-qty><button type="button" data-qv-q="1" aria-label="Increase quantity">+</button></div>' +
        '<button type="button" class="btn btn--primary" data-qv-add>Add to cart</button></div><a class="qv__link" href="' + esc(p.url) + '">View full details</a></div>';
      var pick = function () {
        var vals = (p.options || []).map(function (_, i) { var c = $('[data-qv-opt="' + i + '"]:checked', body); return c ? c.value : null; });
        return p.variants.filter(function (v) { return v.options.every(function (o, i) { return o === vals[i]; }); })[0];
      };
      var refresh = function () {
        var v = pick(), btn = $("[data-qv-add]", body);
        (p.options || []).forEach(function (_, i) {
          var c = $('[data-qv-opt="' + i + '"]:checked', body); $('[data-qv-val="' + i + '"]', body).textContent = c ? c.value : "";
          $$('[data-qv-opt="' + i + '"]', body).forEach(function (inp) {
            var vals = (p.options || []).map(function (_, j) { var cc = $('[data-qv-opt="' + j + '"]:checked', body); return cc ? cc.value : null; });
            vals[i] = inp.value;
            var tv = p.variants.filter(function (x) { return x.options.every(function (o, k) { return o === vals[k]; }); })[0];
            inp.closest(".pill").classList.toggle("unavailable", !tv || !tv.available);
          });
        });
        if (!v) { btn.disabled = true; btn.textContent = "Unavailable"; return; }
        $("[data-qv-price]", body).innerHTML = qvMoney(v.price);
        btn.disabled = !v.available; btn.textContent = v.available ? "Add to cart" : "Sold out";
        if (v.featured_image && v.featured_image.src) { var im = $(".qv__media img", body); if (im) im.src = v.featured_image.src + (v.featured_image.src.indexOf("?") > -1 ? "&" : "?") + "width=700"; }
      };
      body.addEventListener("change", refresh);
      body.addEventListener("click", function (e) {
        var q = e.target.closest("[data-qv-q]"); if (q) { var inp = $("[data-qv-qty]", body); inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(q.dataset.qvQ, 10)); }
        var add = e.target.closest("[data-qv-add]");
        if (add) {
          var v = pick(); if (!v || !v.available) return;
          var qty = Math.max(1, parseInt($("[data-qv-qty]", body).value, 10) || 1);
          S.addAndOpen(v.id, qty, add).then(function () { qv.close(); });
        }
      });
      refresh();
    }).catch(function (err) {
      body.innerHTML = '<p class="qv__loading">' + esc(err.message) + '. <a href="' + root + "products/" + encodeURIComponent(handle) + '">Open the product page</a></p>';
    });
  }
  document.addEventListener("click", function (e) {
    var t = e.target.closest("[data-quick-view]");
    if (!t) return;
    e.preventDefault();
    if (S.closeCart && t.closest("#CartDrawer")) S.closeCart();
    openQV(t.dataset.quickView, t);
  });

  /* ============ predictive search ============ */
  var sIn = $("[data-psearch-input]"), sOut = $("[data-psearch]"), sPop = $("[data-psearch-popular]");
  if (sIn && sOut) {
    var timer, ctrl;
    var renderRes = function (q, j) {
      var res = j.resources && j.resources.results || {};
      var prods = (res.products || []).slice(0, 6), cols = (res.collections || []).slice(0, 3);
      if (!prods.length && !cols.length) { sOut.innerHTML = '<p class="psearch__none">No results for “' + esc(q) + '”.</p>'; return; }
      sOut.innerHTML =
        (prods.length ? '<p class="psearch__h">Products</p><ul class="psearch__list" role="listbox">' + prods.map(function (p) {
          var img = p.featured_image && p.featured_image.url || p.image || "";
          return '<li><a class="psr" href="' + esc(p.url) + '" role="option">' + (img ? '<img src="' + esc(img) + (img.indexOf("?") > -1 ? "&" : "?") + 'width=120" alt="" width="52" height="52" loading="lazy">' : "<span></span>") +
            '<span class="psr__t">' + esc(clean(p.title)) + '</span><span class="psr__p">' + (p.price_min && p.price_max && p.price_min !== p.price_max ? "From " : "") + money(Math.round(parseFloat(p.price_min || p.price) * 100)) + "</span></a></li>";
        }).join("") + "</ul>" : "") +
        (cols.length ? '<p class="psearch__h">Collections</p><div class="psearch__cols">' + cols.map(function (c) { return '<a class="chip" href="' + esc(c.url) + '">' + esc(c.title) + "</a>"; }).join("") + "</div>" : "") +
        '<a class="psearch__all" href="' + (R.search || "/search") + "?type=product&q=" + encodeURIComponent(q) + '">See all results for “' + esc(q) + "”</a>";
    };
    sIn.addEventListener("input", function () {
      var q = sIn.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { sOut.hidden = true; if (sPop) sPop.hidden = false; sIn.setAttribute("aria-expanded", "false"); return; }
      timer = setTimeout(function () {
        if (ctrl && ctrl.abort) ctrl.abort();
        ctrl = window.AbortController ? new AbortController() : null;
        var url = (R.predictive || root + "search/suggest") + ".json?q=" + encodeURIComponent(q) + "&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last";
        fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.json(); }).then(function (j) {
          renderRes(q, j); sOut.hidden = false; if (sPop) sPop.hidden = true; sIn.setAttribute("aria-expanded", "true");
        }).catch(function () {});
      }, 180);
    });
  }

  /* ============ collection: filter & sort sheet ============ */
  var sheet = $("[data-filter-sheet]");
  if (sheet) {
    var scrim = $("[data-filter-scrim]"), openers = $$("[data-filter-open]");
    var openS = function () { sheet.hidden = false; scrim.hidden = false; document.body.style.overflow = "hidden"; openers.forEach(function (b) { b.setAttribute("aria-expanded", "true"); }); requestAnimationFrame(function () { sheet.classList.add("on"); }); };
    var closeS = function () { sheet.classList.remove("on"); scrim.hidden = true; document.body.style.overflow = ""; openers.forEach(function (b) { b.setAttribute("aria-expanded", "false"); }); setTimeout(function () { sheet.hidden = true; }, 300); };
    openers.forEach(function (b) { b.addEventListener("click", openS); });
    scrim.addEventListener("click", closeS);
    $$("[data-filter-close]", sheet).forEach(function (b) { b.addEventListener("click", closeS); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !sheet.hidden) closeS(); });
    /* price inputs are typed in rupees; drop empty fields so the URL stays clean */
    sheet.addEventListener("submit", function () { $$("input", sheet).forEach(function (i) { if ((i.type === "number" || i.type === "text") && i.value === "") i.disabled = true; }); });
  }
  $$("[data-autosubmit]").forEach(function (s) { s.addEventListener("change", function () { s.form.submit(); }); });

  /* ============ read more: collection intro (2 lines) and reviews (4 lines) ============ */
  function clampSetup() {
    $$("[data-clamp]").forEach(function (box) {
      var t = $(".cintro__text", box), b = $("[data-clamp-btn]", box);
      if (!t || !b || b.dataset.ready) return; b.dataset.ready = 1;
      if (t.scrollHeight > t.clientHeight + 2) { b.hidden = false; b.addEventListener("click", function () { var open = box.classList.toggle("is-open"); b.textContent = open ? "Read less" : "Read more"; }); }
    });
    $$("[data-clamp4]").forEach(function (q) {
      var b = q.nextElementSibling; if (!b || !b.matches("[data-more]") || b.dataset.ready) return; b.dataset.ready = 1;
      if (q.scrollHeight > q.clientHeight + 2) { b.hidden = false; b.addEventListener("click", function () { var open = q.classList.toggle("is-open"); b.textContent = open ? "Read less" : "Read more"; }); }
    });
  }
  clampSetup(); addEventListener("load", clampSetup);

  /* ============ image carousels (image with numbered list) ============ */
  $$("[data-img-carousel]").forEach(function (fig) {
    var imgs = $$(".icar__img", fig), dots = $$(".icar__dot", fig);
    if (imgs.length < 2) return;
    var i = 0, delay = (parseInt(fig.dataset.autoplay, 10) || 0) * 1000, timer = null;
    var show = function (n) { i = (n + imgs.length) % imgs.length; imgs.forEach(function (im, k) { im.classList.toggle("is-on", k === i); if (k === i) im.loading = "eager"; }); dots.forEach(function (d, k) { d.classList.toggle("on", k === i); }); };
    var play = function () { if (timer) clearInterval(timer); if (delay && !RM) timer = setInterval(function () { show(i + 1); }, delay); };
    dots.forEach(function (d, k) { d.addEventListener("click", function () { show(k); play(); }); });
    var x0 = null;
    fig.addEventListener("touchstart", function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    fig.addEventListener("touchend", function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) > 40) { show(i + (dx < 0 ? 1 : -1)); play(); } }, { passive: true });
    play();
  });

  /* ============ hero: multiple banners ============ */
  $$("[data-hero-slider]").forEach(function (hs) {
    var slides = $$("[data-hs-slide]", hs), dots = $$("[data-hs-dot]", hs);
    if (slides.length < 2) return;
    var i = 0, timer = null, delay = (parseInt(hs.dataset.autoplay, 10) || 0) * 1000;
    var show = function (n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle("is-on", k === i); s.setAttribute("aria-hidden", k === i ? "false" : "true"); s.inert = k !== i; });
      dots.forEach(function (d, k) { d.classList.toggle("on", k === i); d.setAttribute("aria-current", k === i ? "true" : "false"); });
    };
    var play = function () { stop(); if (delay && !RM) timer = setInterval(function () { show(i + 1); }, delay); };
    var stop = function () { if (timer) clearInterval(timer); timer = null; };
    show(0); hs.classList.add("is-ready"); play();
    var p = $("[data-hs-prev]", hs), nx = $("[data-hs-next]", hs);
    if (p) p.addEventListener("click", function () { show(i - 1); play(); });
    if (nx) nx.addEventListener("click", function () { show(i + 1); play(); });
    dots.forEach(function (d) { d.addEventListener("click", function () { show(+d.dataset.hsDot); play(); }); });
    hs.addEventListener("mouseenter", stop); hs.addEventListener("mouseleave", play);
    hs.addEventListener("focusin", stop);
    var x0 = null;
    hs.addEventListener("touchstart", function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    hs.addEventListener("touchend", function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) > 45) { show(i + (dx < 0 ? 1 : -1)); play(); } }, { passive: true });
    document.addEventListener("visibilitychange", function () { if (document.hidden) stop(); else play(); });
    /* Shopify theme editor: jump to the banner being edited */
    document.addEventListener("shopify:block:select", function (e) { var k = slides.indexOf(e.target); if (k > -1) { show(k); stop(); } });
  });

  /* ============ hero delivery cut-off countdown (IST) ============ */
  $$("[data-countdown]").forEach(function (el) {
    var m = String(el.dataset.countdown).trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?$/);
    if (!m) return;
    var end = Date.UTC(+m[1], +m[2] - 1, +m[3], (+m[4] || 23) - 5, (+m[5] || 59) - 30);
    var out = $("[data-countdown-left]", el);
    var step = function () {
      var ms = end - Date.now();
      if (ms <= 0) { el.hidden = true; return; }
      var d = Math.floor(ms / 864e5), h = Math.floor(ms % 864e5 / 36e5), mi = Math.floor(ms % 36e5 / 6e4), s = Math.floor(ms % 6e4 / 1e3);
      out.textContent = (d ? d + "d " : "") + h + "h " + (mi < 10 ? "0" : "") + mi + "m" + (d ? "" : " " + (s < 10 ? "0" : "") + s + "s");
      el.hidden = false;
      setTimeout(step, d ? 30000 : 1000);
    };
    step();
  });

  /* ============ corporate gifting: lead events after a successful submit ============ */
  var ok = $("[data-lead-success]");
  if (ok && T.trackLeads !== false) {
    try {
      if (typeof window.fbq === "function") window.fbq("track", "Lead", { content_name: "Corporate gifting" });
      if (typeof window.gtag === "function") window.gtag("event", "generate_lead", { form_name: "corporate_gifting" });
      (window.dataLayer = window.dataLayer || []).push({ event: "generate_lead", form_name: "corporate_gifting" });
      /* Shopify customer events: a custom pixel can forward this to Meta and GA4 */
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === "function") Shopify.analytics.publish("generate_lead", { form: "corporate_gifting" });
    } catch (e) {}
    if (ok.scrollIntoView) ok.scrollIntoView({ block: "center" });
  }
})();
